import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@jti/ui";
export const Page404 = () => {
    return (_jsxs("div", { children: [_jsx("h1", { children: "404 Not Found" }), _jsxs("p", { children: ["URL ", window.location.href, " not found."] }), _jsx(Button, { href: window.location.origin, variant: "redirect", children: "Home page" })] }));
};
//# sourceMappingURL=Page404.js.map